<script lang="ts">
  import type { Snippet } from 'svelte';

  interface Props {
    tone?: 'success' | 'warning' | 'danger' | 'info' | 'running' | 'neutral';
    dot?: boolean;
    children: Snippet;
  }

  let { tone = 'neutral', dot = false, children }: Props = $props();
</script>

<span class="badge" data-tone={tone}>
  {#if dot}<span class="dot"></span>{/if}
  {@render children()}
</span>

<style>
  .badge {
    display: inline-flex;
    align-items: center;
    gap: var(--space-1);
    font-size: 11px;
    padding: 2px var(--space-2);
    border-radius: var(--radius-sm);
    border: 1px solid var(--border-strong);
    background: var(--bg-hover);
    color: var(--text-secondary);
    white-space: nowrap;
  }
  .dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: currentColor;
  }
  [data-tone='success'] {
    background: var(--color-success-bg);
    border-color: var(--color-success-border);
    color: var(--color-success);
  }
  [data-tone='warning'] {
    background: var(--color-warning-bg);
    border-color: var(--color-warning-border);
    color: var(--color-warning);
  }
  [data-tone='danger'] {
    background: var(--color-danger-bg);
    border-color: var(--color-danger-border);
    color: var(--color-danger);
  }
  [data-tone='info'] {
    background: var(--color-info-bg);
    border-color: var(--color-info-border);
    color: var(--color-info);
  }
  [data-tone='running'] {
    background: var(--color-running-bg);
    border-color: var(--color-running-border);
    color: var(--color-running);
  }
</style>
